<ng-container>
  <div class="log-metadata">
    <div class="v-center" style="gap: 8px;">
      <div class="log-metadata-time">{{log.eventCreated}}</div>
      <div class="log-metadata-category">
        <div class="badge automation-background" *ngIf="log?.isAutomation">Automation Action</div>
        <div class="badge audio-background" *ngIf="!log?.isAutomation">Manual Audio Event</div>
      </div>
    </div>
    <div class="log-metadata-category">
      <ng-container *ngFor="let list of log.eventCodeList">
        <div class="badge xml-code">{{ list.code }}</div>
      </ng-container>
      <div class="log-metadata-device"> 
        <div class="log-metadata-device-name" [class.no-name]="!log.name">{{log.name ?? 'No Name'}}</div>
        <div class="log-metadata-device-name">{{formatAudioLabel()}}</div>
      </div>
      <div class="log-metadata-other" *ngIf="log?.partnerDescription">{{ log?.partnerDescription }}</div>
    </div>
    <div class="event-log-action-box">
      <div class="audio-action-box audio-background" (click)="toggleAudioPlay($event)">
        <audio #audioControl (ended)="stopAudio()" (loadedmetadata)="loadMetadata()" (timeupdate)="updateProgress()"></audio>
        <div class="loader absolute log-loader" *ngIf="isAudioLoading">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path log-stroke-color" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
          </svg>
        </div>
        <ng-container *ngIf="!isAudioLoading">
          <div class="audio-action-duration-box" #audioProgressBar></div>
          <div class="v-center" style="justify-content: center; height: 100%;"><i class="material-icons audio-icons" style="color: #C34A36; font-size: 24px">mic</i></div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>